import React from "react";
import DeviceShowcase from "../DeviceShowcase";

export default function PrepressMockup() {
  const desktopUI = (
    <div className="w-full h-full flex flex-col text-sm bg-white">
      <div className="bg-slate-50 border-b border-slate-200 p-2 md:p-3 flex items-center justify-between">
        <span className="font-semibold text-slate-700 text-xs md:text-sm">
          Thư viện Khuôn Bế & Kẽm In
        </span>
        <div className="flex gap-2">
          <span className="px-2 py-1 bg-white border border-slate-200 text-slate-700 rounded text-[10px] md:text-xs">
            🔍 Tìm kiếm Khuôn
          </span>
        </div>
      </div>
      <div className="p-3 md:p-4 flex-1 flex flex-col overflow-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
          {/* Item Khuôn 1 */}
          <div className="border border-indigo-200 rounded-lg p-2 bg-indigo-50 shadow-sm relative overflow-hidden">
            <div className="absolute top-0 left-0 w-1 h-full bg-indigo-500"></div>
            <div className="text-[10px] text-indigo-500 font-mono mb-1">
              KB-2025-102
            </div>
            <div className="font-bold text-xs text-indigo-900 mb-1 leading-tight">
              Hộp Mỹ Phẩm X (Bế đứt + Cấn gân)
            </div>
            <div className="flex justify-between items-center text-[9px] mt-2 border-t border-indigo-100 pt-1">
              <span className="text-slate-500">Khổ: 79x109</span>
              <span className="text-indigo-600 font-bold">Vị trí: A12</span>
            </div>
          </div>
          {/* Item Khuôn 2 */}
          <div className="border border-slate-200 rounded-lg p-2 bg-white hover:shadow-md transition-shadow relative overflow-hidden opacity-70">
            <div className="absolute top-0 left-0 w-1 h-full bg-orange-400"></div>
            <div className="text-[10px] text-slate-400 font-mono mb-1">
              KB-2024-055
            </div>
            <div className="font-bold text-xs text-slate-700 mb-1 leading-tight line-through">
              Hộp Yến Sào (Cũ)
            </div>
            <div className="flex justify-between items-center text-[9px] mt-2 border-t border-slate-100 pt-1">
              <span className="text-red-500 font-bold">Hỏng dao bế</span>
              <span className="text-slate-400 font-bold">Vị trí: B05</span>
            </div>
          </div>
        </div>

        <div className="bg-slate-50 rounded-lg p-3 border border-slate-200">
          <h4 className="text-xs font-bold text-slate-700 mb-2">
            Chi tiết Lệnh Xuất Kẽm: #PRE-089
          </h4>
          <div className="grid grid-cols-2 gap-2 text-[10px] md:text-xs">
            <div className="bg-white p-2 rounded border border-slate-100">
              <div className="text-slate-500">Số lượng kẽm</div>
              <div className="font-bold text-slate-800">4 tấm (C, M, Y, K)</div>
            </div>
            <div className="bg-white p-2 rounded border border-slate-100">
              <div className="text-slate-500">Hệ màu</div>
              <div className="font-bold text-slate-800">
                CMYK + 1 Panton (Nhũ Vàng)
              </div>
            </div>
            <div className="bg-white p-2 rounded border border-slate-100">
              <div className="text-slate-500">Tram</div>
              <div className="font-bold text-slate-800">175 lpi</div>
            </div>
            <div className="bg-white p-2 rounded border border-slate-100">
              <div className="text-slate-500">Máy in ghép</div>
              <div className="font-bold text-slate-800">
                Komori Lithrone G40
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const mobileUI = (
    <div className="w-full h-full flex flex-col bg-slate-900 text-slate-200">
      <div className="p-4 bg-gradient-to-b from-indigo-900/50 to-slate-900 border-b border-slate-800 flex justify-between items-center z-10">
        <div>
          <div className="text-[10px] text-indigo-400 font-bold uppercase tracking-wider">
            Phòng Chế Bản
          </div>
          <div className="text-sm font-bold text-white">
            Xuất Kẽm & Bình Bài
          </div>
        </div>
        <div className="w-8 h-8 rounded-full bg-indigo-500/20 flex items-center justify-center border border-indigo-500/30">
          🛠️
        </div>
      </div>

      <div className="flex-1 p-3 overflow-y-auto space-y-3 relative">
        {/* Visual Representation of CMYK plates */}
        <div className="bg-slate-800 p-3 rounded-xl border border-slate-700 shadow-md">
          <div className="text-xs font-bold text-white mb-2">
            Trạng thái ghi Kẽm - PO #089
          </div>
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <div className="w-6 h-6 rounded bg-cyan-500/20 text-cyan-400 font-bold flex items-center justify-center text-xs">
                C
              </div>
              <div className="flex-1 h-1.5 bg-slate-700 rounded-full overflow-hidden">
                <div className="h-full w-full bg-cyan-500"></div>
              </div>
              <span className="text-[9px] text-cyan-400">Xong</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-6 h-6 rounded bg-fuchsia-500/20 text-fuchsia-400 font-bold flex items-center justify-center text-xs">
                M
              </div>
              <div className="flex-1 h-1.5 bg-slate-700 rounded-full overflow-hidden">
                <div className="h-full w-full bg-fuchsia-500"></div>
              </div>
              <span className="text-[9px] text-fuchsia-400">Xong</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-6 h-6 rounded bg-yellow-500/20 text-yellow-400 font-bold flex items-center justify-center text-xs">
                Y
              </div>
              <div className="flex-1 h-1.5 bg-slate-700 rounded-full overflow-hidden">
                <div className="h-full w-[45%] bg-yellow-500 animate-pulse"></div>
              </div>
              <span className="text-[9px] text-yellow-400">45%</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-6 h-6 rounded bg-slate-950 text-slate-400 border border-slate-700 font-bold flex items-center justify-center text-xs">
                K
              </div>
              <div className="flex-1 h-1.5 bg-slate-700 rounded-full overflow-hidden">
                <div className="h-full w-0 bg-slate-500"></div>
              </div>
              <span className="text-[9px] text-slate-500">Chờ</span>
            </div>
          </div>
        </div>

        <button className="w-full bg-slate-800 border border-indigo-500/50 text-indigo-400 py-2.5 rounded-lg text-xs font-bold hover:bg-slate-700 transition-colors">
          Mở File Bình Bài (PDF)
        </button>
      </div>
    </div>
  );

  return <DeviceShowcase desktopUI={desktopUI} mobileUI={mobileUI} />;
}
